import {
  FETCH_SALES_ANALYTICS_DATA,
  RESET_SALES_ANALYTICS_DATA,
} from "../../constants/action.constants";

const initialState = {
  data: [],
};

const salesAnalyticsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SALES_ANALYTICS_DATA:
      return { data: action.payload };
    case RESET_SALES_ANALYTICS_DATA:
      return initialState;
    default:
      return state;
  }
};

export default salesAnalyticsReducer;
